import React, { useEffect, useRef } from 'react';
import './Features.css';
import useScrollReveal from '../../../utils/useScrollReveal';

const FEATURES = [
  { num: '01', icon: '🤖', color: 'blue', title: 'AI Question Generation', desc: 'Automatically generates role-specific, industry-relevant questions using advanced AI no manual question banks needed.' },
  { num: '02', icon: '📝', color: 'green', title: 'Intelligent Response Evaluation', desc: 'Evaluates candidate answers for accuracy, depth, and communication quality with objective, bias-free AI scoring.' },
  { num: '03', icon: '👥', color: 'blue', title: 'Organization & Recruiter Management', desc: 'Organizations can add recruiters, assign job roles, and manage permissions with complete pipeline visibility.' },
  { num: '04', icon: '📈', color: 'green', title: 'Result Management & Analytics', desc: 'Ranked shortlists, score breakdowns, and interview analytics in one place shareable with stakeholders in one click.' },
  { num: '05', icon: '📄', color: 'blue', title: 'AI Job Description Generator', desc: 'Generate precise, compelling job descriptions in seconds. Just enter the role and let AI craft industry-standard JDs tailored to your requirements.' },
  { num: '06', icon: '🛡️', color: 'green', title: 'Anti-Cheat Engine', desc: 'Tab switches, face proctoring and our multi-layer integrity system catches what others miss. Cheating tools fail against us.' },
];

export default function Features() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); }
      }),
      { threshold: 0.12 }
    );
    ref.current?.querySelectorAll('.feat-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

 return (
  <div className="marketing-theme" ref={ref}>
    <div className="feat-header">
      <div className="section-label">Features</div>
      <h2 className="section-title">Built for Smart Hiring Teams</h2>
      <p className="section-sub">Everything needed to run a Scalable, Fair, and Intelligent hiring process all in one platform.</p>
    </div>

    <div className="feat-grid">
      {FEATURES.map((f, i) => (
        <div
          key={f.num}
          className={`feat-card feat-card-${f.color}`}
          style={{ '--delay': `${i * 0.08}s` }}
        >
          <div className="feat-card-top">
            <div className={`feat-icon fi-${f.color}`}>{f.icon}</div>
            {/* <span className="feat-num">{f.num}</span> */}
          </div>
          <h3 className="feat-title">{f.title}</h3>
          <p className="feat-desc">{f.desc}</p>
          <div className={`feat-glow glow-${f.color}`} />
        </div>
      ))}
    </div>
  </div>
);
}